import type { CreateSourceState } from "@/pages/sources/components/create/sources/types";

export enum CreateSourceWebhookPhase {
  CONFIGURE = "CONFIGURE",
  CREATING = "CREATING",
  LISTENING = "LISTENING",
  CONFIRMED = "CONFIRMED",
  ERROR = "ERROR",
}

export interface WebhookCredentials {
  webhookUrl: string;
  webhookSecret: string;
}

export type CreateSourceWebhookState = CreateSourceState & {
  phase: CreateSourceWebhookPhase;
  signatureHeader: string;
  batchIntervalSeconds: number | null;
  batchMaxSize: number | null;
  credentials: WebhookCredentials | null;
  sourceId: string | null;
};
